// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const EquipmentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M11.15 3.8h.54c2.82-.12 2.64.39 2.64 2.92v3.64c0 .57-.1 2.09.21 2.48q.22.28.58.32c.4.04.86-.2.9-.63.12-1.47.03-2.97.06-4.45.01-.85-.03-1.7.03-2.54.51.15 1.24.54 1.68.85q3.32 2.39 3.5 6.48c.03.54.04 2.26.11 2.65-.9.06-2.09.02-3 .02H2.65c0-2.25-.18-4.14.95-6.26.9-1.67 2.46-3.2 4.32-3.73l.01 4.48c0 .76-.04 1.65.02 2.4.02.24.22.5.38.67 1.55.43 1.33-1.28 1.33-2.24v-3.8c0-.74-.05-1.51.02-2.24.08-.83.8-.96 1.47-1.01" />
      <path
        d="M3.04 17.28c.84-.04 1.9 0 2.77 0H17.4c1.34 0 2.73-.05 4.05.06.5.04 1.05.82 1.05 1.31s-.1.75-.42 1.12c-.32.35-.6.38-1.04.41H21c-.65.07-2.06.02-2.78.02H6.29c-1.12 0-2.2.02-3.36-.01-1.33-.04-1.8-1.35-1.11-2.4.22-.36.82-.47 1.22-.5"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default EquipmentIcon;
